import { responseToVelavuRequestError } from "../error/error";
import { PAGINATION_HEADER_CONTINUATION_TOKEN } from "../data/paginated-result";
import { getConfig } from "./config";
const DEFAULT_ENDPOINT = "https://api.velavu.com";
/**
 * Builds a Velavu API URL with query parameters
 */
export function buildURL(path, queryParams) {
    const config = getConfig();
    const url = new URL(path, config.endpoint ?? DEFAULT_ENDPOINT);
    if (queryParams) {
        for (const [key, value] of Object.entries(queryParams)) {
            url.searchParams.append(key, value);
        }
        ;
    }
    return url.toString();
}
/**
 * Add pagination parameters to query params
 */
export function paginateQueryParams(params, queryParams = {}) {
    if (params === undefined) {
        return queryParams;
    }
    const result = { ...queryParams };
    if (params.continuationToken !== undefined) {
        result["continuation_token"] = params.continuationToken;
    }
    if (params.limit !== undefined) {
        result["limit"] = String(params.limit);
    }
    return result;
}
/**
 * Parse a paginated response
 */
export function parsePaginatedResponse(data, headers) {
    const continuationToken = headers.get(PAGINATION_HEADER_CONTINUATION_TOKEN) ?? undefined;
    return { data, continuationToken };
}
/**
 * Maps a record with simple JavaScript primitives to a record
 * with string-only values
 */
export function simplifyStringRecord(obj) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        // Skip undefined values
        if (value !== undefined) {
            acc[key] = String(value);
        }
        return acc;
    }, {});
}
/**
 * Wrapper around fetch that makes the following changes:
 * - Automatically adds authentication headers
 * - Handles errors consistently
 * - Automatically adds the endpoint to the URL if it is not provided
 */
export async function fetchWithAuth(url, options = {}) {
    const effectiveURL = new URL(url, getConfig().endpoint ?? DEFAULT_ENDPOINT);
    const authToken = await getConfig().getToken();
    //Build fetch options
    const fetchOptions = {
        ...options,
        headers: {
            ...options.headers,
            Authorization: `Bearer ${authToken}`
        }
    };
    //Make the request
    const response = await fetch(effectiveURL, fetchOptions);
    //Check for errors
    if (!response.ok) {
        throw await responseToVelavuRequestError(response);
    }
    return response;
}
/**
 * Wrapper around fetchWithAuth that parses the response as JSON
 */
export async function fetchJSON(url, options = {}) {
    const response = await fetchWithAuth(url, options);
    //Check the content type
    const contentType = response.headers.get("Content-Type");
    if (contentType !== "application/json") {
        throw new Error(`Expected application/json, got ${contentType}`);
    }
    //Parse the response body as JSON
    const text = await response.text();
    return JSON.parse(text);
}
/**
 * Wrapper around fetchWithAuth that parses the response as JSON and returns a paginated result
 */
export async function fetchPaginatedJSON(url, options = {}) {
    const response = await fetchWithAuth(url, options);
    const text = await response.text();
    const data = JSON.parse(text);
    return parsePaginatedResponse(data, response.headers);
}
//# sourceMappingURL=fetch-utils.js.map